export const isLoading = (state) => state.loading

export const leurisProfile = (state) => state.leurisProfile

export const fisPersid = (state) => state.fisPersid

export const favouredResearchActivity = (state) => state.favouredResearchActivity

export const name = (state) => state.name

export const getData = (state) => state.data

export const getSchema = (state) => state.listSchema

export const getFilterSchema = (state) => state.filterSchema[state.resourceType]

export const getResourceType = (state) => state.resourceType

export const getConfig = (state) => state.config

export const getTotal = (state) => state.total

export const getActiveTab = (state) => state.activeTab

export const getId = (state) => state.id

export const getFilter = (state) => state.filter

export const resourceTypes = (state) => state.resourceTypes

export const getLabel = (state) => state.label

export const getPage = (state) => state.config[state.resourceType].page

export const getPerPage = (state) => state.config[state.resourceType].perPage

export const getSortField = (state) => state.config[state.resourceType].sortField

export const getSortOrder = (state) => state.config[state.resourceType].sortOrder



// WEBPACK FOOTER //
// ./src/store/modules/aboutme/getters.js